/**
 * FollowUpCreatePage - Page for creating new follow-ups
 */

import React from "react";
import FollowUpForm from "../components/FollowUpForm.jsx";

/**
 * FollowUpCreatePage Component
 */
const FollowUpCreatePage = () => {
  return <FollowUpForm />;
};

export default FollowUpCreatePage;

